/**
 * gift ticket return Component
 */
(function () {

    'use strict';

    /**
     * help content
     * @name giftTicketReturnCtrl
     * @type ItxGiftTicketReturnCmpCtrl
     */
    var ItxGiftTicketReturnCmp = {
        bindings: {
            barcodeTxt: '@',
            btnTxt: '@'
        },
        controller: ItxGiftTicketReturnCmpCtrl,
        controllerAs: 'giftTicketReturnCtrl',
        templateUrl: 'itx-gift-ticket-return.component.html'
    };

    ItxGiftTicketReturnCmpCtrl.$inject = ['$scope', 'ngDialog', '$stateParams', 'ItxLoaderFct', 'ItxErrorMessagesFct'];

    function ItxGiftTicketReturnCmpCtrl($scope, ngDialog, $stateParams, ItxLoaderFct, ItxErrorMessagesFct) {
        var _this = this;
        _this.giftTicketReturnModel = {};

        _this.returnRequest = function () {
            _this.giftTicketReturnForm.$setSubmitted();
            if (_this.giftTicketReturnForm.$valid) {

                //get order
                ItxLoaderFct.show();
                joyr.rest.xRestGetOrderIdFromBarCode(_this.giftTicketReturnModel.barcode, _this.giftTicketReturnModel.captchaResponse)
                    .done(function (response) {
                        resetForm();
                        //open dialog
                        ngDialog.open({
                            template: '<itx-my-account-order-return order="ngDialogData.order" is-gift-ticket="true"></itx-my-account-order-return>',
                            className: 'ngdialog-theme-plain ngdialog-order-return',
                            plain: true,
                            showClose: true,
                            data: {
                                order: response[0].order
                            }
                        });
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.dialog(error.errorMessage);
                    })
                    .Finally(function () {
                        ItxLoaderFct.hide();
                        $scope.$broadcast('captcha:reloadImage');
                        $scope.$apply();
                    });
            }
        };

        function resetForm() {
            if (_this.giftTicketReturnForm) {
                _this.giftTicketReturnModel = {};
                _this.giftTicketReturnForm.$setPristine();
                _this.giftTicketReturnForm.$setUntouched();
            }
        }
    }

    /** Public */
    angular.module('itxApp.help')
        .component('itxGiftTicketReturn', ItxGiftTicketReturnCmp);

})();

